/**
 * Admin Configuration
 * 
 * This file contains centralized configuration for admin functionality.
 * In test mode, only one specific admin user is allowed.
 */

// The email of the single admin user allowed in test mode
export const ADMIN_EMAIL = 'yemam011@gmail.com'; // Replace with your actual admin email

// Admin access code
export const ADMIN_ACCESS_CODE = 'StudentHelperAdmin2023';

// Admin configuration
export const ADMIN_UID = 'ja4ltNcQ4TczJ8BV4W75zRK6FOr1';

// Helper function to check if a user is the admin
export const isAdmin = (uid) => {
  return uid === ADMIN_UID;
};

// Helper function to check admin role in database
export const hasAdminRole = (userData) => {
  if (!userData) return false;
  return userData.role === 'admin';
};

// Admin authentication expiration time (24 hours in milliseconds)
export const ADMIN_AUTH_EXPIRATION = 24 * 60 * 60 * 1000; 